/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close-selected': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 0C229.273 0 0 229.273 0 512s229.273 512 512 512 512-229.273 512-512S794.727 0 512 0zm241.36 701.668a36.571 36.571 0 11-51.715 51.715L512 563.715 322.355 753.36a36.571 36.571 0 11-51.715-51.715L460.285 512 270.64 322.355a36.571 36.571 0 0151.715-51.715L512 460.285 701.645 270.64a36.571 36.571 0 0151.715 51.715L563.715 512z"/>'
  }
})
